import Cookies from "universal-cookie"

import config from "../config"
import getCompleteApiUrl from "../getCompleteApiUrl"
import {OperatorReadinessRequirement} from "../../classes/OperatorReadinessRequirement";
import {ApiCallFailure} from "../../classes/exception/ApiCallFailure";

export default async function createReadinessRequirementInOperatorById(requirement: OperatorReadinessRequirement) {
    const cookies = new Cookies()

    if (cookies.get("accessToken") === undefined) {
        const error = new ApiCallFailure()
        error.connectionSuccessful = false
        error.errorType = "NO_ACCESS_TOKEN"

        throw error
    }

    var res: Response
    try {
        res = await fetch(getCompleteApiUrl(config, `/operators/id/${requirement.operatorId}/readiness/requirements`), {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${cookies.get("accessToken")}`
            },
            body: JSON.stringify({
                subject: requirement.subject,
                certificationIssued: requirement.certificationIssued.format(),
                certificationExpires: requirement.certificationExpires.format(),
            }),
        })
    } catch (error) {
        const apiFailure = new ApiCallFailure()
        apiFailure.connectionSuccessful = false

        throw apiFailure
    }

    if (res!.status === 201) {
        const responseObject = await res!.json()

        const responseRequirement = new OperatorReadinessRequirement()
        responseRequirement.parseObject(responseObject)

        return responseRequirement
    }

    const callFailure = new ApiCallFailure()
    callFailure.connectionSuccessful = true
    callFailure.responseCode = res!.status
    callFailure.errorType = "REQUEST_REJECTED"

    throw callFailure
}